/** composing string to only numbers */
export const getOnlyNumbers = (str: string): string => {
  return str.match(/\d/g)?.join("") || "";
};
